<div class="container">
  <div class="row">
    <div class="col-12 text-center" [class.d-none]="!!page">
      <i class="fa-spinner fa-spin fa fa-2x text-muted my-5"></i>
    </div>
    <div class="col" >
      <div [innerHTML]="content"></div>
    </div>
  </div>
</div>
